import { apiURL } from "./constants";
import axios from "axios";

/**
 * TODO(permissions #116): No frontend helper yet for
 * GET /api/shipment_payment/{id}/ (payments_view).
 * Permission: PERMISSIONS.PAYMENTS_VIEW.
 * PaymentsScreen currently renders row detail from the list response.
 * When adding the helper + UI, gate the caller via
 * <PermissionGate /> or hasPermission().
 * See ENDPOINTS_USAGE.md Phase 7.
 */

/**
 * TODO(permissions #117): No frontend helper yet for
 * POST /api/shipment_payment/ (payments_create).
 * Permission: PERMISSIONS.PAYMENTS_CREATE.
 * Payments are currently created via #125 (`addShipmentPayment`) and
 * #126 (`addInvoicePayment`) below. When a direct create helper is added,
 * gate the caller via <PermissionGate /> or hasPermission().
 * See ENDPOINTS_USAGE.md Phase 7.
 */


export async function getPayments(params = {}) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.get(`${apiURL}/api/payment/list/`, {
        params,
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response;
}

export async function updatePayment(id, payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.put(`${apiURL}/api/payment/update/${id}/`, payload, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response;
}

export async function deletePayment(id) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.delete(`${apiURL}/api/payment/delete/${id}/`, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    });
    return response;
}

export async function addShipmentPayment(payload) {

    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    // POST request using axios with error handling
    const response = await axios.post(`${apiURL}/api/add_shipment_payment/`,
        payload,
        {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }
    )
        .catch((error) => {
            console.error('There was an error!', error);
            throw error;
        });

    return response;
}

export async function addInvoicePayment(payload) {

    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    // POST request using axios with error handling
    const response = await axios.post(`${apiURL}/api/add_invoice_payment/`,
        payload,
        {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }
    )
        .catch((error) => {
            console.error('There was an error!', error);
            throw error;
        });

    return response;
}

export async function confirmPayment(paymentId, confirm = true) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.post(
        `${apiURL}/api/payment/confirm/${paymentId}/`,
        { confirm },
        {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }
    );
    return response;
}

export async function bulkConfirmPayments(paymentIds, confirm = true) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.post(
        `${apiURL}/api/payment/bulk_confirm/`,
        {
            payment_ids: paymentIds,
            confirm
        },
        {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }
    );
    return response;
}

/**
 * Refund a payment (all methods: Paymob, Thawani, Cash, Transfer, Online, Cheque).
 * @param {number} paymentId - Internal Payment record ID
 * @param {object} options - Optional: { amount?: number, reason?: string }
 * @returns {Promise<{data: object}>} API response
 */
export async function refundPayment(paymentId, options = {}) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const body = { payment_id: paymentId };
    if (options.amount != null) body.amount = options.amount;
    if (options.reason) body.reason = options.reason;

    const response = await axios.post(
        `${apiURL}/api/payment/refund/`,
        body,
        {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }
    );
    return response;
}